import React from 'react';

const SearchIcon: React.FunctionComponent = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.67" cy="10.67" r="8" stroke="#888" strokeWidth="2" />
    <path d="M21 21l-4.35-4.35" stroke="#888" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default SearchIcon;
